// Remembers how many quizzes a visitor has seen in the header menu, so its
// counter stops shouting once opened and lights up again when a quiz is added.
const KEY = "bidmio.quizMenu.seen";

export const readSeenCount = (): number => {
  if (typeof window === "undefined") return 0;
  try {
    const value = Number.parseInt(localStorage.getItem(KEY) ?? "", 10);
    return Number.isFinite(value) && value > 0 ? value : 0;
  } catch {
    return 0;
  }
};

export const writeSeenCount = (count: number) => {
  try {
    localStorage.setItem(KEY, String(count));
  } catch {
    // storage unavailable (private mode etc.) — the badge stays neutral for this session
  }
};
